<template>
  <div class="space-y-6">
    <NewSmsMessageAction
      v-if="$membershipHasPermissionTo('create sms messages')"
      :contact="contact"
      @created="setLastCreatedAt"
    />
    <MessageList :key="lastCreatedAt" :contact="contact" />
  </div>
</template>

<script>
import NewSmsMessageAction from './NewSmsMessageAction.vue';
import MessageList from './MessageList.vue';

export default {
  components: {
    NewSmsMessageAction,
    MessageList,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lastCreatedAt: null,
    };
  },
  methods: {
    setLastCreatedAt() {
      this.lastCreatedAt = new Date().getTime();
    },
  },
};
</script>
